import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

const InputGroup = ({
  type,
  options,
  defaultValue,
  inputValue,
  maxLength,
  onSelectChange,
  onInputChange,
  label,
  error,
  onBlur,
  disabled,
}) => {
  const ref = useRef();
  const [isFocus, setIsFocus] = useState(false);

  return (
    <>
      <div className={`field-group ${error ? 'error' : ''}`}>
        <select
          onChange={({ target }) => onSelectChange(target.value)}
          disabled={disabled}
        >
          {options.map((option) => (
            <option
              defaultValue={option.value === defaultValue}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
        <div className="input-field">
          <input
            ref={ref}
            autoComplete="off"
            type={type}
            maxLength={maxLength}
            value={inputValue}
            onChange={({ target }) => onInputChange(target.value)}
            onFocus={() => setIsFocus(true)}
            onBlur={() => {
              onBlur();
              setIsFocus(false);
            }}
            disabled={disabled}
          />
          <label
            onClick={() => ref.current.focus()}
            className={(inputValue !== '' || isFocus) ? 'active' : ''}
          >
            {label}
          </label>
        </div>
      </div>
      {error && (
        <span className="show-error">{error}</span>
      )}
    </>
  );
};

InputGroup.propTypes = {
  type: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })).isRequired,
  defaultValue: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  maxLength: PropTypes.string.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default InputGroup;
